import { graphql } from '@/generated/gql';

export const SOURCING_CASE_FLOW_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseFlow($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        flow {
          id
          status
          steps {
            id
            variant
            status
            hidden
          }
        }
      }
    }
  }
`);
